// extracted by mini-css-extract-plugin
export default {"input":"Bda-z","button":"Cda-z","selected":"Dda-z","unavailable":"Eda-z","oos":"Fda-z","image":"Gda-z","paperCutDisabledOverlay":"Hda-z"};